/* //scr/index.js */


import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const getScriptInnerHtml = (attr) => {
  return document.querySelector(`script[${attr}]`)?.innerHTML?.trim();
};
document.addEventListener("DOMContentLoaded", () => {
  const root = ReactDOM.createRoot(
    document.getElementById("ketonaid-widget")
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  
  window.chargezenProduct = getScriptInnerHtml("ketonaid-product-json");


  
  if (window.chargezenProduct) {
    window.chargezenProduct = JSON.parse(window.chargezenProduct);
  }


  // --- Start of New Code ---

  // Get URL parameters from the current browser tab
  const urlParams = new URLSearchParams(window.location.search);
  
  // Create a global object to store the desired URL details
  window.chargezenUrlParams = {
    variant: urlParams.get('variant') || null,
    utm_source: urlParams.get('utm_source') || null,
  };

  // You can log them to the console to verify they are being captured
  console.log("Captured URL Parameters:", window.chargezenUrlParams);

  // --- End of New Code ---


  window.chargezenLocale = {
    per_bag: getScriptInnerHtml("chargezen-subGift-perbag") || "",
    oneTimeLocale: {
      headingTitle:
        getScriptInnerHtml("chargezen-subGift-oneTime-heading") ||
        "Try Once",
      headingSubTitle:
        getScriptInnerHtml("chargezen-subGift-oneTime-subheading") ||
        "",
    },
    subscriptionLocale: {
      headingTitle:
        getScriptInnerHtml("chargezen-subGift-sub-heading") ||
        "<strong>Auto-Ship & Save 10%</strong>",
      KE4headingTitle:
        getScriptInnerHtml("chargezen-subGift-sub-heading") ||
        "<strong>Auto-Ship & Save 10%</strong>",
      headingSubTitle:
        getScriptInnerHtml("chargezen-subGift-sub-subheading") ||
        "Easily pause, or cancel at any time",
    },
  };

  const preferencePayload = getScriptInnerHtml("chargezen-subGift-preferences");
  window.chargezenPreferences = preferencePayload ? JSON.parse(preferencePayload) : {};

});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
